import React from 'react';
import './ModalDre.css';  

const ModalDreContasEmitidas = ({ isOpen, onClose, dados }) => {
    if (!isOpen) return null;

    return (
        <div id="modal-overlay" onClick={onClose}>
            <div id="modal-content" onClick={(e) => e.stopPropagation()}>
                <h2>Informações de Contas Emitidas</h2>
                <table>
                    <thead>
                        <tr>
                            <th>SEQ</th>
                            <th>Data Emissão</th>
                            <th>Descrição</th>
                            <th>Valor</th>
                            <th>Juros</th>
                            <th>Multa</th>
                            <th>Desconto</th>
                            <th>Saldo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dados.map((item, index) => (
                            <tr key={index}>
                                <td>{item.SEQ}</td>
                                <td>{new Date(item.DATA_EMISSAO).toLocaleDateString()}</td>
                                <td>{item.DESCRICAO}</td>
                                <td>{Number(item.VALOR).toLocaleString("pt-BR",{style: 'currency', currency: "BRL"})}</td>
                                <td>{Number(item.JUROS).toLocaleString("pt-BR",{style: 'currency', currency: "BRL"})}</td>
                                <td>{Number(item.MULTA).toLocaleString("pt-BR",{style: 'currency', currency: "BRL"})}</td>
                                <td>{Number(item.DESCONTO).toLocaleString("pt-BR",{style: 'currency', currency: "BRL"})}</td>
                                <td>{Number(item.TOTAL_PAGAR).toLocaleString("pt-BR",{style: 'currency', currency: "BRL"})}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <button id="close-btn" className='mt-3' onClick={onClose}>Fechar</button>
            </div>
        </div>
    );
};

export default ModalDreContasEmitidas;